// export const API_HOST = "https://dgsservices.malabargroup.com"
// export const API_HOST = "http://localhost:8000"
export const API_HOST = "https://test.dgsservices.malabargroup.com"
